const SUBSCRIPTION_STORAGE_KEY = 'user_subscription';

export const setStoredSubscription = (data) => {
  if (data == null) {
    localStorage.removeItem(SUBSCRIPTION_STORAGE_KEY);
    return;
  }

  localStorage.setItem(SUBSCRIPTION_STORAGE_KEY, JSON.stringify(data));
};

export const getStoredSubscription = () => {
  try {
    const raw = localStorage.getItem(SUBSCRIPTION_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
};

export const clearStoredSubscription = () => {
  localStorage.removeItem(SUBSCRIPTION_STORAGE_KEY);
};
